import banffImage from './assets/images/banff-bg-graphic-texture.svg';
export const banffColors = {
  '--GW-BACKGROUND-COLOR-BODY': '#f0f1f5',
  '--GW-BACKGROUND-IMAGE': "#131e2e url(\"".concat(banffImage, "\")")
};